import React from 'react';


export default function TopBanner(props) {

    return (
        props.banners && props.banners.length > 0 ?
            <div className=" fullWidth highZIndex_2" style={{
                backgroundColor: "white",
                position: "fixed",
                overflow: "hidden",
                top: 0,
                width: '100%',

            }}>
                {
                    props.banners.map((image, i) => {
                        return <div
                            style={{width: image.width + '%', height: image.width * (image.height / 100) + "px"}}
                            onClick={() => {
                                props.onClicked(image)
                            }}>
                            <img src={image.image} style={{width: '100%', height: '100%'}} alt={"cover"}
                                 className={"clickable"}/>
                        </div>
                    })
                }

            </div> : <div/>

    )
}